import { feedbacksService } from 'app/modules/shared/services/feedbacks.service'
import { FeedbackReport } from '../types/feedback'

export async function handleFeedbackSubmit(options: {
  type: 'product' | 'report'
  report?: FeedbackReport
  score?: number
  isUseful?: boolean
  description?: string
  isSuccess: (canSubmit: boolean) => void
}) {
  const feedbackData = {
    type: options.type,
    report: options.report ?? undefined,
    score: options.score ?? undefined,
    is_useful: options.isUseful ?? undefined,
    description: options.description ?? undefined,
  }

  try {
    await feedbacksService.submitFeedback(feedbackData)
    options.isSuccess(true)
  } catch (error: any) {
    if (error?.response?.status === 403) {
      console.error('You have already submitted feedback for this version:', error)
      options.isSuccess(false)
      return
    }
    console.error('Failed to submit feedback:', error)
  }
}
